import {ANNOTATION_VIDEO_DISPLAY, ANNOTATION_PARENT, VIDEO_PLAYING_MODE} from './GlobalConstants';
import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';
export const CANTALOUPE_IMAGE_SERVER = "http://18.130.251.124:8080/iiif/2/test01%2Fmichael-hill%2Fshow-01%2F";

const AnnotationsDB = [

    /* Michael Hill*/
    // Wall 1
    {

        paintingId: 'W01P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W01P01.jpg`,
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}W01P01.jpg/info.json`,
        headerText: `<h5>INTENSE 1</h5>`,
        emailSubjectText: `Enquiry about Intense 1`,
        bodyText: `Crayon and acrylic on paper<br>42 x 60cm<br>£60<br>Wall 1 presents the ”Intense” series. It reflects a grim mood and period of self reflection and frustration during the early months of 2020. Some of the brighter colours perhaps hint at a more optimistic mood later in the year`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',


    },
    {

        paintingId: 'W01P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W01P02.jpg`,
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}W01P02.jpg/info.json`,
        headerText: `<h5>INTENSE 2</h5>`,
        emailSubjectText: `Enquiry about Intense 2`,
        bodyText: `Acrylic and ink on paper<br>42 x 60cm<br>£60<br>Wall 1 presents the ”Intense” series. It reflects a grim mood and period of self reflection and frustration during the early months of 2020. Some of the brighter colours perhaps hint at a more optimistic mood later in the year`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {
        paintingId: 'W01P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W01P03.jpg`,
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}W01P03.jpg/info.json`,
        headerText: `<h5>INTENSE 3</h5>`,
        emailSubjectText: `Enquiry about Intense 3`,
        bodyText: `Acrylic on paper<br>42 x 60cm<br><b>SOLD</b><br>Wall 1 presents the ”Intense” series. It reflects a grim mood and period of self reflection and frustration during the early months of 2020. Some of the brighter colours perhaps hint at a more optimistic mood later in the year`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W01P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W01P04.jpg`,
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}W01P04.jpg/info.json`,
        headerText: `<h5>INTENSE 4</h5>`,
        emailSubjectText: `Enquiry about Intense 4`,
        bodyText: `Acrylic and ink on paper<br>42 x 60cm<br>£60<br>Wall 1 presents the ”Intense” series. It reflects a grim mood and period of self reflection and frustration during the early months of 2020. Some of the brighter colours perhaps hint at a more optimistic mood later in the year`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W01P05',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W01P05.jpg`,
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}W01P05.jpg/info.json`,
        headerText: `<h5>INTENSE 5</h5>`,
        emailSubjectText: `Enquiry about Intense 5`,
        bodyText: `Acrylic and ink on paper<br>42 x 60cm<br>£60<br>Wall 1 presents the ”Intense” series. It reflects a grim mood and period of self reflection and frustration during the early months of 2020. Some of the brighter colours perhaps hint at a more optimistic mood later in the year`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W01P06',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W01P06.jpg`,
        // iiifSource: `${CANTALOUPE_IMAGE_SERVER}W01P06.jpg/info.json`,
        headerText: `<h5>INTENSE 6</h5>`,
        emailSubjectText: `Enquiry about Intense 6`,
        bodyText: `Acrylic on paper<br>42 x 60cm<br>£60<br>Wall 1 presents the ”Intense” series. It reflects a grim mood and period of self reflection and frustration during the early months of 2020. Some of the brighter colours perhaps hint at a more optimistic mood later in the year`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    // Wall 2
    {

        paintingId: 'W02P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P01.jpg`,
        headerText: `<h5>BLURRED</h5>`,
        emailSubjectText: `Enquiry about Blurred`,
        bodyText: `Acrylic and ink on paper<br>42 x 60cm<br>£60<br>Wall 2 is a continuation and variation on the “Intense” theme with messages of entrapment, restriction, fleeing the unknown and uncertainty over the future. The themes seem to present several challenges to mankind. Is our future in our own hands or beyond our control?`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },

    {

        paintingId: 'W02P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P02.jpg`,
        headerText: `<h5>RED DEVIL</h5>`,
        emailSubjectText: `Enquiry about Red Devil`,
        bodyText: `Acrylic and ink on paper<br>42 x 60cm<br>£60<br>Wall 2 is a continuation and variation on the “Intense” theme with messages of entrapment, restriction, fleeing the unknown and uncertainty over the future. The themes seem to present several challenges to mankind. Is our future in our own hands or beyond our control?`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W02P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P03.jpg`,
        headerText: `<h5>BLUE EYES</h5>`,
        emailSubjectText: `Enquiry about Blue Eyes`,
        bodyText: `Acrylic and ink on paper<br>40 x 40cm<br><b>SOLD</b><br>Wall 2 is a continuation and variation on the “Intense” theme with messages of entrapment, restriction, fleeing the unknown and uncertainty over the future. The themes seem to present several challenges to mankind. Is our future in our own hands or beyond our control?`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W02P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P04.jpg`,
        headerText: `<h5>ORIENTAL SKIES</h5>`,
        emailSubjectText: `Enquiry about Oriental Skies`,
        bodyText: `Acrylic and emulsion on paper<br>42 x 60cm<br>Limited Edition Print £40<br>Wall 2 is a continuation and variation on the “Intense” theme with messages of entrapment, restriction, fleeing the unknown and uncertainty over the future. The themes seem to present several challenges to mankind. Is our future in our own hands or beyond our control?`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W02P05',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P05.jpg`,
        headerText: `<h5>AQUASCAPE</h5>`,
        emailSubjectText: `Enquiry about Aquascape`,
        bodyText: `Acrylic and emulsion on paper<br>42 x 60cm<br>Limited Edition Print £40<br>Wall 2 is a continuation and variation on the “Intense” theme with messages of entrapment, restriction, fleeing the unknown and uncertainty over the future. The themes seem to present several challenges to mankind. Is our future in our own hands or beyond our control?`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W02P06',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P06.jpg`,
        headerText: `<h5>EYES ON THE EXODUS</h5>`,
        emailSubjectText: `Enquiry about Eyes on the Exodus`,
        bodyText: `Mixed media - crayon, chalk, acrylic, spray and emulsion paint on board<br>70 x 70cm<br>£90<br>Wall 2 is a continuation and variation on the “Intense” theme with messages of entrapment, restriction, fleeing the unknown and uncertainty over the future. The themes seem to present several challenges to mankind. Is our future in our own hands or beyond our control?`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W02P07',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P07.jpg`,
        headerText: `<h5>STARWAY</h5>`,
        emailSubjectText: `Enquiry about Starway`,
        bodyText: `Acrylic and emulsion on paper<br>42 x 60cm<br>£40<br>Wall 2 is a continuation and variation on the “Intense” theme with messages of entrapment, restriction, fleeing the unknown and uncertainty over the future. The themes seem to present several challenges to mankind. Is our future in our own hands or beyond our control?`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W02P08',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W02P08.jpg`,
        headerText: `<h5>ENTOMBED</h5>`,
        emailSubjectText: `Enquiry about Entombed`,
        bodyText: `Acrylic and emulsion on paper<br>60 x 42cm<br>£60<br>Wall 2 is a continuation and variation on the “Intense” theme with messages of entrapment, restriction, fleeing the unknown and uncertainty over the future. The themes seem to present several challenges to mankind. Is our future in our own hands or beyond our control?`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    // Wall 3
    {

        paintingId: 'W03P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P01.jpg`,
        headerText: `<h5>WATCHER OF THE SKIES</h5>`,
        emailSubjectText: `Enquiry about Watcher of the skies`,
        bodyText: `Mixed media - crayon, chalk, acrylic, spray and emulsion paint on board<br>100 x 122cm<br>£90<br>Wall 3 continues the theme of what may befall mankind- both positive and negative. There are reminders that man’s tenure on Earth is ephemeral and cannot be taken for granted.`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W03P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P02.jpg`,
        headerText: `<h5>SENTIENT</h5>`,
        emailSubjectText: `Enquiry about Sentient`,
        bodyText: `Acrylic and emulsion on board<br>65 x 100cm<br>£90<br>Wall 3 continues the theme of what may befall mankind- both positive and negative. There are reminders that man’s tenure on Earth is ephemeral and cannot be taken for granted.<br>”Sentient” gives the message that other living beings on the planet have as many rights as we have.`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W03P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P03.jpg`,
        headerText: `<h5>MORTAL REMAINS</h5>`,
        emailSubjectText: `Enquiry about Mortal Remains`,
        bodyText: `Acrylic and emulsion on board<br>65 x 100cm<br>£90<br>Wall 3 continues the theme of what may befall mankind- both positive and negative. There are reminders that man’s tenure on Earth is ephemeral and cannot be taken for granted.<br>“Mortal Remains” points out what may happen if we take the wrong steps..`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W03P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P04.jpg`,
        headerText: `<h5>IN PINK</h5>`,
        emailSubjectText: `Enquiry about In Pink`,
        bodyText: `Acrylic and emulsion on paper<br>40 x 40cm<br><b>SOLD</b><br>Wall 3 continues the theme of what may befall mankind- both positive and negative. There are reminders that man’s tenure on Earth is ephemeral and cannot be taken for granted.`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W03P05',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P05.jpg`,
        headerText: `<h5>THE FUTURE IS ORANGE 1</h5>`,
        emailSubjectText: `Enquiry about The Future is Orange 1`,
        bodyText: `Acrylic and emulsion on paper<br>42 x 60cm<br>£40<br>Wall 3 continues the theme of what may befall mankind- both positive and negative. There are reminders that man’s tenure on Earth is ephemeral and cannot be taken for granted.<br>The “Orange” series shows that the future can be positive but with doubts over the form this may take`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W03P06',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P06.jpg`,
        headerText: `<h5>THE FUTURE IS ORANGE 2</h5>`,
        emailSubjectText: `Enquiry about The Future is Orange 2`,
        bodyText: `Acrylic and emulsion on paper<br>40 x 40cm<br>£40<br>Wall 3 continues the theme of what may befall mankind- both positive and negative. There are reminders that man’s tenure on Earth is ephemeral and cannot be taken for granted.<br>The “Orange” series shows that the future can be positive but with doubts over the form this may take`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W03P07',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P07.jpg`,
        headerText: `<h5>THE FUTURE IS ORANGE 3</h5>`,
        emailSubjectText: `Enquiry about The Future is Orange 3`,
        bodyText: `Acrylic and emulsion on paper<br>40 x 40cm<br>£40<br>Wall 3 continues the theme of what may befall mankind- both positive and negative. There are reminders that man’s tenure on Earth is ephemeral and cannot be taken for granted.<br>The “Orange” series shows that the future can be positive but with doubts over the form this may take`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W03P08',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P08.jpg`,
        headerText: `<h5>L’ORAGE</h5>`,
        emailSubjectText: `Enquiry about L'orage`,
        bodyText: `Acrylic and emulsion on paper<br>40 x 40cm<br>Limited Edition of 10 print £40<br>Wall 3 continues the theme of what may befall mankind- both positive and negative. There are reminders that man’s tenure on Earth is ephemeral and cannot be taken for granted.`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    // Wall 4
    {

        paintingId: 'W04P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P01.jpg`,
        headerText: `<h5>FIESTA</h5>`,
        emailSubjectText: `Enquiry about Fiesta`,
        bodyText: `Acrylic and emulsion on paper<br>40 x 40cm<br>Limited Edition of 10 print £40<br>Wall 4 ends the exhibition on a positive note with a hoped for return to some degree of normality, but hopefully with lessons learned on our fragility as a species.<br>COVID 19 has provided a warning that we must modify our behaviour towards the planet and all its inhabitants otherwise the lifestyle we have become accustomed to is in serious jeopardy.<br>When we have ”opened up” our new lives this may be less materialistic but in a society that is more caring and focussed on quality of life not quantity`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },

    {

        paintingId: 'W04P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P02.jpg`,
        headerText: `<h5>TANGO</h5>`,
        emailSubjectText: `Tango`,
        bodyText: `Acrylic and emulsion on paper<br>40 x 40cm<br>Limited Edition of 10 print £40<br>Wall 4 ends the exhibition on a positive note with a hoped for return to some degree of normality, but hopefully with lessons learned on our fragility as a species.<br>COVID 19 has provided a warning that we must modify our behaviour towards the planet and all its inhabitants otherwise the lifestyle we have become accustomed to is in serious jeopardy.<br>When we have ”opened up” our new lives this may be less materialistic but in a society that is more caring and focussed on quality of life not quantity`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W04P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P03.jpg`,
        headerText: `<h5>FLICK SHOW</h5>`,
        emailSubjectText: `Enquiry about Flick Show`,
        bodyText: `Acrylic and emulsion on paper<br>40 x 40cm<br>Limited Edition of 10 print £40<br>Wall 4 ends the exhibition on a positive note with a hoped for return to some degree of normality, but hopefully with lessons learned on our fragility as a species.<br>COVID 19 has provided a warning that we must modify our behaviour towards the planet and all its inhabitants otherwise the lifestyle we have become accustomed to is in serious jeopardy.<br>When we have ”opened up” our new lives this may be less materialistic but in a society that is more caring and focussed on quality of life not quantity`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W04P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P04.jpg`,
        headerText: `<h5>AJAR</h5>`,
        emailSubjectText: `Enquiry about Ajar`,
        bodyText: `Acrylic and emulsion on paper<br>60 x 42cm<br>£40<br>Wall 4 ends the exhibition on a positive note with a hoped for return to some degree of normality, but hopefully with lessons learned on our fragility as a species.<br>COVID 19 has provided a warning that we must modify our behaviour towards the planet and all its inhabitants otherwise the lifestyle we have become accustomed to is in serious jeopardy.<br>When we have ”opened up” our new lives this may be less materialistic but in a society that is more caring and focussed on quality of life not quantity`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W04P05',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P05.jpg`,
        headerText: `<h5>HAPPY CONTOURS</h5>`,
        emailSubjectText: `Enquiry about Happy Contours`,
        bodyText: `Acrylic and emulsion on paper<br>60 x 60cm<br>£70<br>Wall 4 ends the exhibition on a positive note with a hoped for return to some degree of normality, but hopefully with lessons learned on our fragility as a species.<br>COVID 19 has provided a warning that we must modify our behaviour towards the planet and all its inhabitants otherwise the lifestyle we have become accustomed to is in serious jeopardy.<br>When we have ”opened up” our new lives this may be less materialistic but in a society that is more caring and focussed on quality of life not quantity`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W04P06',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P06.jpg`,
        headerText: `<h5>HIGH JINKS</h5>`,
        emailSubjectText: `Enquiry about High Jinks`,
        bodyText: `Acrylic and emulsion on paper<br>60 x 42cm<br>£60<br>Wall 4 ends the exhibition on a positive note with a hoped for return to some degree of normality, but hopefully with lessons learned on our fragility as a species.<br>COVID 19 has provided a warning that we must modify our behaviour towards the planet and all its inhabitants otherwise the lifestyle we have become accustomed to is in serious jeopardy.<br>When we have ”opened up” our new lives this may be less materialistic but in a society that is more caring and focussed on quality of life not quantity`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W04P07',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P07.jpg`,
        headerText: `<h5>ORANGERY</h5>`,
        emailSubjectText: `Enquiry about Orangery`,
        bodyText: `Acrylic and emulsion on paper<br>42 x 60cm<br>£40<br>Wall 4 ends the exhibition on a positive note with a hoped for return to some degree of normality, but hopefully with lessons learned on our fragility as a species.<br>COVID 19 has provided a warning that we must modify our behaviour towards the planet and all its inhabitants otherwise the lifestyle we have become accustomed to is in serious jeopardy.<br>When we have ”opened up” our new lives this may be less materialistic but in a society that is more caring and focussed on quality of life not quantity`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
    {

        paintingId: 'W04P08',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P08.jpg`,
        headerText: `<h5>OPEN UP 1</h5>`,
        emailSubjectText: `Enquiry about Open up 1`,
        bodyText: `Acrylic on paper<br>42 x 60cm<br>£40<br>Wall 4 ends the exhibition on a positive note with a hoped for return to some degree of normality, but hopefully with lessons learned on our fragility as a species.<br>COVID 19 has provided a warning that we must modify our behaviour towards the planet and all its inhabitants otherwise the lifestyle we have become accustomed to is in serious jeopardy.<br>When we have ”opened up” our new lives this may be less materialistic but in a society that is more caring and focussed on quality of life not quantity`,
        EnquireEmail: 'michaelhillart@btinternet.com',
        ContactURL: 'http://www.michaelhillart.co.uk/',
    },
];

export {AnnotationsDB};
